/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {useEffect} from 'react';
import {filterDeviceFileTypesByDevicesPlatformIds, filterDeviceFileTypesByPermissions} from '@ion/core/src/utils/DeviceFileUtils';
import {useFilePermissionsAction} from '../../hooks/useFilePermissionsAction';

/**
 * React Hook to filter device file type based on user file permissions.
 *
 *  ```typescript
 *   import {useFilePermissionsJobCreation} from '@ion/applications/src/components/jobs';
 *
 *   const {hasPermissions} = useFilePermissionsJobCreation();
 *  ```
 */
export const useFilePermissionsJobCreation = ({
  Features,
  deviceTypes,
  enablePlatformApis,
  deviceFileTypes,
  setFilteredDeviceFileTypes,
  has400Error = false,
  isFetching = false
}) => {
  const filePermissions = useFilePermissionsAction({
    Features,
    isDeviceFile : false,
    isEditor     : true
  });

  useEffect(() => {
    if (deviceTypes?.length) {
      const filteredTypes = filterDeviceFileTypesByPermissions(Features, filePermissions, deviceTypes);
      if (enablePlatformApis && !isFetching && !has400Error) {
        if (deviceFileTypes?.length) {
          const filteredDeviceTypes = filterDeviceFileTypesByDevicesPlatformIds(deviceFileTypes, filteredTypes);
          setFilteredDeviceFileTypes(filteredDeviceTypes);
        } else {
          setFilteredDeviceFileTypes([]);
        }
      } else {
        setFilteredDeviceFileTypes(filteredTypes);
      }
    }
  }, [deviceTypes, enablePlatformApis, isFetching, has400Error]);
};

export default useFilePermissionsJobCreation;
